import React from 'react'
import "../styles/footer.css"
import { useTheme } from '../contexts/NewThemeContext';

export const Footer = () => {
    const { companyLogo } = useTheme();

    return (
        <div className='footer-container'>
            <p className='description'>
                © 2025 Movyx Tecnologia SA. Todos os direitos reservados.
            </p>
            <img className='logo' src={companyLogo} alt="movyx-logo" />
        </div>
    )
}
